import type { Candidate, JsonObject } from "@/types/issuePipeline";

/** Stored capture and automatic TC failures; only evidence supplied by the server. */
export function candidateFailures(item: Candidate) {
  return (item.sources ?? []).flatMap((source) => {
    if (source.source_kind !== "capture_failure" && source.source_kind !== "auto_tc_failure") return [];
    const details = source.details;
    if (!details || typeof details !== "object" || Array.isArray(details)) return [];
    const { code, message } = details as JsonObject;
    const storedCode = typeof code === "string" && code.trim() ? code : null;
    const storedMessage = typeof message === "string" && message.trim() ? message : null;
    return storedCode || storedMessage ? [{ sourceKind: source.source_kind, code: storedCode, message: storedMessage }] : [];
  });
}

const VERDICTS: Record<string, string> = { reproduced: "재현됨", not_reproduced: "재현 안 됨", undetermined: "판정 불가" };

/** The retired 2차's stored result, labelled as past; null when the server sends none. */
export function verdictLabel(item: Candidate) {
  const verdict = item.generalization_job?.verdict;
  if (!verdict) return null;
  return `이전 방식 · ${VERDICTS[verdict] ?? `재현 ${verdict}`}`;
}
